import { Check, X } from "lucide-react";

const forList = [
  "First-time founders drowning in ideas but stuck on which to pursue",
  "Solopreneurs with notebooks full of \"someday\" projects",
  "Wantrepreneurs ready to stop collecting ideas and start validating them",
];

const notForList = [
  "Teams needing project management (use Asana)",
  "People who want complex workflows (use Notion)",
  "Anyone looking for a second brain system (this is a spark catcher, not a knowledge base)",
];

const AudienceSection = () => {
  return (
    <section className="section-padding bg-background">
      <div className="section-container">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16">
          {/* Who This Is For */}
          <div>
            <h2 className="text-sm font-semibold uppercase tracking-widest text-primary mb-6">
              Who This Is For
            </h2>
            <ul className="space-y-4">
              {forList.map((item) => (
                <li key={item} className="flex gap-3 items-start">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary flex items-center justify-center mt-0.5">
                    <Check className="w-4 h-4 text-secondary-foreground" />
                  </div>
                  <span className="text-foreground leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Who This Is NOT For */}
          <div>
            <h2 className="text-sm font-semibold uppercase tracking-widest text-muted-foreground mb-6">
              Who This Is NOT For
            </h2>
            <ul className="space-y-4">
              {notForList.map((item) => (
                <li key={item} className="flex gap-3 items-start">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-muted flex items-center justify-center mt-0.5">
                    <X className="w-4 h-4 text-muted-foreground" />
                  </div>
                  <span className="text-muted-foreground leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;
